const OPEN_SEARCH_EVENT = "ifag:open-search";
const CLOSE_SEARCH_EVENT = "ifag:close-search";
const FOCUSABLE_SELECTOR = "button:not([disabled]), input:not([disabled])";

const closeMobileMenu = () => {
  document.dispatchEvent(new CustomEvent("ifag:close-menu"));
};

export const openSearchModal = trigger => {
  document.dispatchEvent(new CustomEvent(OPEN_SEARCH_EVENT, { detail: { trigger } }));
};

export const closeSearchModal = (restoreFocus = true) => {
  document.dispatchEvent(new CustomEvent(CLOSE_SEARCH_EVENT, { detail: { restoreFocus } }));
};

export const initSearchModal = () => {
  const modal = document.getElementById("ifag-search-modal");

  if (!modal) {
    return;
  }

  const accessibility = document.querySelector(".ifag-accessibility");
  const closeButton = modal.querySelector("[data-ifag-search-close]");
  const form = modal.querySelector("#ifag-main-search");
  const headerTriggers = Array.from(document.querySelectorAll(".header-ifag__search__button"));
  const input = form?.querySelector(".ifag-search-modal__input");
  let previouslyFocusedElement = null;

  if (!form || !input) {
    return;
  }

  const isOpen = () => !modal.hidden;

  const closeSearch = (restoreFocus = true) => {
    if (!isOpen()) {
      return;
    }

    modal.hidden = true;
    document.body.classList.remove("ifag-search-modal-open");
    headerTriggers.forEach(trigger => trigger.setAttribute("aria-expanded", "false"));
    input.value = "";

    if (restoreFocus && previouslyFocusedElement?.isConnected) {
      previouslyFocusedElement.focus();
    }

    previouslyFocusedElement = null;
  };

  const openSearch = trigger => {
    closeMobileMenu();

    if (!isOpen()) {
      previouslyFocusedElement = trigger ?? document.activeElement;
    }

    modal.hidden = false;
    document.body.classList.add("ifag-search-modal-open");
    headerTriggers.forEach(headerTrigger => headerTrigger.setAttribute("aria-expanded", "true"));
    requestAnimationFrame(() => input?.focus());
  };

  const trapFocus = event => {
    if (event.key !== "Tab" || !isOpen()) {
      return;
    }

    const focusableElements = Array.from(modal.querySelectorAll(FOCUSABLE_SELECTOR));
    if (focusableElements.length === 0) {
      return;
    }

    const firstElement = focusableElements[0];
    const lastElement = focusableElements[focusableElements.length - 1];

    if (!modal.contains(document.activeElement)) {
      event.preventDefault();
      firstElement.focus();
      return;
    }

    if (event.shiftKey && document.activeElement === firstElement) {
      event.preventDefault();
      lastElement.focus();
    } else if (!event.shiftKey && document.activeElement === lastElement) {
      event.preventDefault();
      firstElement.focus();
    }
  };

  headerTriggers.forEach(headerTrigger => {
    headerTrigger.addEventListener("click", () => openSearch(headerTrigger));
  });
  closeButton?.addEventListener("click", () => closeSearch());

  modal.addEventListener("click", event => {
    if (event.target === modal) {
      closeSearch();
    }
  });

  modal.addEventListener("keydown", trapFocus);

  document.addEventListener("keydown", event => {
    if (event.key === "Escape") {
      closeSearch();
    }
  });

  document.addEventListener(OPEN_SEARCH_EVENT, event => {
    openSearch(event.detail?.trigger);
  });

  document.addEventListener(CLOSE_SEARCH_EVENT, event => {
    closeSearch(event.detail?.restoreFocus ?? true);
  });

  accessibility?.addEventListener("click", () => closeSearch(false), true);

  form?.addEventListener("submit", event => {
    event.preventDefault();

    const term = input.value.trim();

    if (term) {
      location.href = `/busca?${new URLSearchParams({ term })}`;
    }
  });
};
